module.exports = __webpack_public_path__ + "img/Rear.4231996b.jpg";